import { RemoteUpdateRecurringPushNotification } from 'data/usecases/push-notification/remote-update-recurring-push-notification';
import { UpdateRecurringPushNotificationUseCaseInterface } from 'domain/usecases/push-notification/update-recurring-push-notification';
import { makeApiUrlRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeUpdateRecurringPushNotification =
  (): UpdateRecurringPushNotificationUseCaseInterface =>
    new RemoteUpdateRecurringPushNotification(
      makeApiUrlRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
